import './IconPlay.css';
import React from 'react';
var IconHeart = function IconHeart(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? 12 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 14 : _ref$height,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/React.createElement("svg", {
    className: "".concat(className, " ").concat(styles),
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 12 14"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 66",
    d: "M24.117,32.374V23.626L31.177,28ZM33.576,27.3l-9.882-6.123A1.193,1.193,0,0,0,23.063,21,.983.983,0,0,0,22,21.876V34.124A.983.983,0,0,0,23.063,35a1.19,1.19,0,0,0,.631-.177L33.576,28.7A.79.79,0,0,0,33.576,27.3Z",
    transform: "translate(-22 -21)"
  }));
};
var styles = "sueyvor";
export default IconHeart;